export const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST';
export const SET_CUSTOMER_LIST = 'SET_CUSTOMER_LIST';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const EDIT_CUSTOMER_SUCCESS = 'EDIT_CUSTOMER_SUCCESS';
